import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { CannedResponseSelectionComponent } from './canned-response-selection.component';

@NgModule({
  imports: [CommonModule, FormsModule, ReactiveFormsModule, MatSelectModule],
  declarations: [CannedResponseSelectionComponent],
  exports: [CannedResponseSelectionComponent],
})
export class CannedResponseSelectionModule {
}
